import {
    Box,
    Button,
    CloseButton,
    Dialog,
    DialogPositioner,
    Flex,
    IconButton,
    Portal
} from "@chakra-ui/react"
import { EventHandler, useState } from "react"
import { LuSettings, LuTvMinimal, LuUserRound, LuMessageCircleMore, LuVolume2, LuInfo, LuUserRoundPen  } from "react-icons/lu"
import { AboutPage, AccountPage, ChatsPage, GeneralPage } from "./ui/settings-pages";
import { DialogActionTrigger, DialogBackdrop, DialogBody, DialogCloseTrigger, DialogContent, DialogFooter, DialogHeader, DialogRoot, DialogTitle, DialogTrigger } from "./ui/dialog";

interface SettingsModalProps {
    fontFamily: string,
}

interface SettingsSidebarProps {
    fontFamily: string,
    handlePageChange: Function,
    activePage: string,
}

export const SettingsSidebar = ( props: SettingsSidebarProps) => {
    
    const [generalHover, setGeneralHover] = useState(false);
    const [interfaceHover, setInterfaceHover] = useState(false);
    const [personalHover, setPersonalHover] = useState(false);
    const [audioHover, setAudioHover] = useState(false);
    const [chatsHover, setChatsHover] = useState(false);
    const [accountHover, setAccountHover] = useState(false);
    const [aboutHover, setAboutHover] = useState(false);

    

    return(
        <Box fontFamily={props.fontFamily} display={'flex'} flexDirection={'column'} width={'200px'} justifyContent={'flex-start'} alignItems={'flex-start'}>
            <Button p={0} id='general' onClick={(e) => {props.handlePageChange(e)}} color={generalHover || props.activePage == 'general' ? 'colorPalette.fg' : 'colorPalette.fg/50'} onMouseEnter={() => { setGeneralHover(true) }} onMouseLeave={() => { setGeneralHover(false) }} variant={'plain'}><LuSettings id='general' /> General</Button>
            {/* <Button p={0} id='interface' onClick={(e) => {props.handlePageChange(e);}} color={interfaceHover || props.activePage == 'interface' ? 'colorPalette.fg' : 'colorPalette.fg/50'} onMouseEnter={() => { setInterfaceHover(true) }} onMouseLeave={() => { setInterfaceHover(false) }} variant={'plain'}><LuTvMinimal id='interface' /> Interface</Button> */}
            {/* <Button p={0} id='personal' onClick={(e) => {props.handlePageChange(e);}} color={personalHover || props.activePage == 'personal' ? 'colorPalette.fg' : 'colorPalette.fg/50'} onMouseEnter={() => { setPersonalHover(true) }} onMouseLeave={() => { setPersonalHover(false) }} variant={'plain'}><LuUserRoundPen id='personal' /> Personalization</Button> */}
            {/* <Button p={0} id='audio' onClick={(e) => {props.handlePageChange(e);}} color={audioHover || props.activePage == 'audio' ? 'colorPalette.fg' : 'colorPalette.fg/50'} onMouseEnter={() => { setAudioHover(true) }} onMouseLeave={() => { setAudioHover(false) }} variant={'plain'}><LuVolume2 id='audio' /> Audio</Button> */}
            <Button p={0} id='chats' onClick={(e) => {props.handlePageChange(e);}} color={chatsHover || props.activePage == 'chats' ? 'colorPalette.fg' : 'colorPalette.fg/50'} onMouseEnter={() => { setChatsHover(true) }} onMouseLeave={() => { setChatsHover(false) }} variant={'plain'}><LuMessageCircleMore id='chats' /> Chats</Button>
            <Button p={0} id='account' onClick={(e) => {props.handlePageChange(e);}} color={accountHover || props.activePage == 'account' ? 'colorPalette.fg' : 'colorPalette.fg/50'} onMouseEnter={() => { setAccountHover(true) }} onMouseLeave={() => { setAccountHover(false) }} variant={'plain'}><LuUserRound id='account' /> Account</Button>
            <Button p={0} id='about' onClick={(e) => {props.handlePageChange(e);}} color={aboutHover || props.activePage == 'about' ? 'colorPalette.fg' : 'colorPalette.fg/50'} onMouseEnter={() => { setAboutHover(true) }} onMouseLeave={() => { setAboutHover(false) }} variant={'plain'}><LuInfo id='about' /> Support</Button>
        </Box>
    )
}

export const SettingsModal = (props: SettingsModalProps) => {

    const [activePage, setActivePage] = useState('general')

    const handlePageChange = (e : React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        setActivePage(e.currentTarget.id);
    }

    const settingsPage = () => {

        switch (activePage) {
            case 'general':
                return <GeneralPage fontFamily={props.fontFamily} />
            // case 'interface':
            //     return <InterfacePage fontFamily={props.fontFamily} />
            // case 'personal':
            //     return <PersonalizationPage fontFamily={props.fontFamily} />
            // case 'audio':
            //     return <AudioPage fontFamily={props.fontFamily} />
            case 'chats':
                return <ChatsPage fontFamily={props.fontFamily} />
            case 'account':
                return <AccountPage fontFamily={props.fontFamily} />
            case 'about':
                return <AboutPage fontFamily={props.fontFamily} />
            default:
                return <GeneralPage fontFamily={props.fontFamily} />
        }
    }

    return (
        <Dialog.Root size={'xl'} placement={'center'} motionPreset="slide-in-bottom"
            // All nested JSX elements are now explicitly passed to the 'children' prop
            children={
                <>
            <Dialog.Trigger asChild>
                <IconButton variant="ghost" size="sm" css={{
                    _icon: {
                        width: "5",
                        height: "5",
                    },
                }} >
                    <LuSettings />
                </IconButton>
            </Dialog.Trigger>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Header pb={'0'} pl={'1.85rem'}>
                            <Dialog.Title fontSize={'xl'} fontWeight={'400'} fontFamily={props.fontFamily}>Settings</Dialog.Title>
                        </Dialog.Header>
                        <Dialog.Body>
                            <Flex flexDir={'row'} gap={1}>
                                <SettingsSidebar activePage={activePage} handlePageChange={handlePageChange} fontFamily={props.fontFamily} />
                                {settingsPage()}
                            </Flex>
                        </Dialog.Body>
                        <Dialog.Footer fontFamily={props.fontFamily}>
                            {/* <Dialog.ActionTrigger asChild>
                                <Button variant="outline">Cancel</Button>
                            </Dialog.ActionTrigger>
                            <Button>Save</Button> */}
                        </Dialog.Footer>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton position={'absolute'} insetInlineEnd={"0.5rem"} top={"0.5rem"} size="sm" />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
                </>
}
        />
    )
}

